module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/dock-management/dock-management.component.css
// module id = ./src/app/component/dock-management/dock-management.component.css
// module chunks = main